import React, { useEffect, useRef, useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import CommonTable from "../../components/commonTable/commonTable";
import CategoryService from "../../services/category.service";
import CollectionService from "../../services/collection.service";
import { ToastContainer } from "react-toastify";
import useDialogState from "../../hook";

// Custom debounce hook
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const Image = () => {
  const dropdownRefCategory = useRef();
  const dropdownRefCollection = useRef();
  const [data, setData] = useState([]);
  const [collectionData, setCollectionData] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [searchTextInput, setSearchTextInput] = useState("");
  const [searchTextCollectionInput, setSearchTextCollectionInput] = useState("");
  const [searchCategoryOutside, setSearchCategoryOutside] = useState(false);
  const [searchCollectionOutside, setSearchCollectionOutside] = useState(false);

  // Debounced values for API calls
  const debouncedSearchTextInput = useDebounce(searchTextInput, 300);
  const debouncedSearchTextCollectionInput = useDebounce(searchTextCollectionInput, 300);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState("");
  const [imageType, setImageType] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [lastSortedColumn, setLastSortedColumn] = useState("");

  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const handleChange = (e) => {
    setSearchText(e.target.value);
    setSearchTextInput("");
  };
  const handleChangeCategory = (e) => {
    setSearchTextInput(e.target.value);
    setSearchText("");
    setSearchCategoryOutside(true);
  };

  const handleChangeCollection = (e) => {
    setSearchTextCollectionInput(e.target.value);
    setSearchText("");
    setSearchCollectionOutside(true);
  };

  const handleSort = (column) => {
    // If it's a different column than last time, reset click count
    if (column !== lastSortedColumn) {
      // setClickCount(0);
      setLastSortedColumn(column);
      return; // First click on new column - don't call API
    }

    // Increment click count
    // setClickCount((prev) => prev + 1);

    // Set sortBy based on column
    if (column === "downloadCount") {
      setSortBy("DOWNLOAD");
    } else if (column === "favorites") {
      setSortBy("FAVOURITE");
    }

    // Toggle sortOrder
    setSortOrder((prev) => (prev === "ASC" ? "DESC" : "ASC"));
  };

  const getAllImagesList = async () => {
    // Only call API if sortBy is set (after first click)
    const response = await CategoryService.GetAllImages(
      pageNumber,
      pageSize,
      debouncedSearchTextInput,
      searchText,
      imageType,
      sortBy,
      sortOrder,
      debouncedSearchTextCollectionInput
    );
    const data = response.data.apiresponse.data;
    setDataTable(data);
    setTotalCount(data.totalCount);
    // unSetLoader();
  };

  const getAllCategory = async () => {
    const response = await CategoryService.GetAllCategory(
      0,
      0,
      searchTextInput
    );
    const data = response.data.apiresponse.data;
    setData(data.categories);
  };

  const getAllCollections = async () => {
    const response = await CollectionService.GetAllCollection(
      0,
      0,
      searchTextCollectionInput
    );
    const data = response.data.apiresponse.data;
    setCollectionData(data?.collections);
  };

  useEffect(() => {
    getAllImagesList();
  }, [
    pageSize,
    pageNumber,
    debouncedSearchTextInput,
    debouncedSearchTextCollectionInput,
    searchText,
    imageType,
    sortBy,
    sortOrder,
  ]);

  useEffect(() => {
    getAllCategory();
  }, []);

  useEffect(() => {
    getAllCollections();
  }, []);

  const CategoryOption = data.map((item) => {
    return {
      label: item.categoryName,
      value: item.id,
    };
  });

  const CollectionOption = collectionData.map((item) => {
    return {
      label: item.collectionName,
      value: item.id,
    };
  });

  const filteredCategories = CategoryOption.filter((item) =>
    item.label.toLowerCase().includes(searchTextInput.toLowerCase())
  );

  const filteredCollections = CollectionOption.filter((item) =>
    item.label.toLowerCase().includes(searchTextCollectionInput.toLowerCase())
  );

  const handleChangeOptoion = (e) => {
    setImageType(e.value);
  };

  return (
    <>
      <div className="w-full px-5 pb-10">
        <div className="py-10">
          <h1 className="text-base font-semibold leading-7 text-white">
            Multimedia List ( Images / Videos / Gifs )
          </h1>
        </div>
        <div>
          <div className="relative mb-5 z-70">
            <div className="input flex items-center gap-1">
              <div className="flex gap-1 items-center bg-transparent w-full">
                <IoSearchOutline className="bg-transparent text-22" />
                <input
                  type="text"
                  className="input"
                  placeholder="Search....."
                  onChange={handleChange}
                  value={searchText}
                />
              </div>
              {searchText !== "" && (
                <IoClose
                  className="bg-transparent text-22 cursor-pointer"
                  onClick={() => {
                    setSearchText("");
                  }}
                />
              )}
            </div>
          </div>
          <div
            className="relative mb-5 z-70"
            onClick={() => setSearchCategoryOutside(!searchCategoryOutside)}
          >
            <div className="input flex items-center gap-1">
              <div className="flex gap-1 items-center bg-transparent w-full">
                <IoSearchOutline className="bg-transparent text-22" />
                <input
                  type="text"
                  className="input"
                  placeholder="Search By Category"
                  onChange={handleChangeCategory}
                  value={searchTextInput}
                />
              </div>
              {searchTextInput !== "" && (
                <IoClose
                  className="bg-transparent text-22 cursor-pointer"
                  onClick={() => {
                    setSearchTextInput("");
                    setSearchCategoryOutside(false);
                  }}
                />
              )}
            </div>
            {searchCategoryOutside && (
              <div
                className="absolute top-14 w-full rounded-6 overflow-hidden"
                ref={dropdownRefCategory}
              >
                <ul className="bg-gray-800 min-h-10 max-h-80 overflow-y-auto">
                  {filteredCategories.length > 0 ? (
                    filteredCategories.map((item, index) => (
                      <li
                        key={index}
                        className="bg-transparent hover:text-white cursor-pointer text-gray-400 p-2"
                        onClick={() => {
                          setSearchTextInput(item.label);
                        }}
                      >
                        {item.label}
                      </li>
                    ))
                  ) : (
                    <li className="bg-transparent text-gray-400 p-2">
                      No data found
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
          <div
            className="relative mb-5 z-60"
            onClick={() => setSearchCollectionOutside(!searchCollectionOutside)}
          >
            <div className="input flex items-center gap-1">
              <div className="flex gap-1 items-center bg-transparent w-full">
                <IoSearchOutline className="bg-transparent text-22" />
                <input
                  type="text"
                  className="input"
                  placeholder="Search By Collection"
                  onChange={handleChangeCollection}
                  value={searchTextCollectionInput}
                />
              </div>
              {searchTextCollectionInput !== "" && (
                <IoClose
                  className="bg-transparent text-22 cursor-pointer"
                  onClick={() => {
                    setSearchTextCollectionInput("");
                    setSearchCollectionOutside(false);
                  }}
                />
              )}
            </div>
            {searchCollectionOutside && (
              <div
                className="absolute top-14 w-full rounded-6 overflow-hidden"
                ref={dropdownRefCollection}
              >
                <ul className="bg-gray-800 min-h-10 max-h-80 overflow-y-auto">
                  {filteredCollections.length > 0 ? (
                    filteredCollections.map((item, index) => (
                      <li
                        key={index}
                        className="bg-transparent hover:text-white cursor-pointer text-gray-400 p-2"
                        onClick={() => {
                          setSearchTextCollectionInput(item.label);
                        }}
                      >
                        {item.label}
                      </li>
                    ))
                  ) : (
                    <li className="bg-transparent text-gray-400 p-2">
                      No data found
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
        <CommonTable
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          totalCount={totalCount}
          pageSize={pageSize}
          pageNumber={pageNumber}
          tableData={dataTable.images}
          countList={dataTable}
          getAllData={getAllImagesList}
          searchTextCategory={categoryId}
          load={loader}
          handleChangeOptoion={handleChangeOptoion}
          onSort={handleSort}
        />
        <ToastContainer />
      </div>
    </>
  );
};

export default Image;
